import '../App.css';
import img_tablet from '../tablet.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import axios from 'axios';
import V2Card from '../V2Card';
import DeviceMenu from './DeviceMenu';
import V2Warning from './V2Warning';

function DeviceHeader() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [device, setDevice] = useState(null);

    // TODO: remove dup.
    function getDevice(device_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            {}
        ).then(
            (response) => {
                setDevice(response.data);
            }
        )
    }

    useEffect(
        () => {
            getDevice(searchParams.get('device_id'));
        },
        [],
    )

    return (
        <div>
            <V2Card>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        margin: '1em',
                    }}
                >
                    <div style={{ marginRight: '1em' }}>
                        <img src={img_tablet} width={180} />
                    </div>
                    <div>
                        <div className='mk2-title'>
                            {device?.title}
                        </div>
                        {/* <div>
                            <V2Warning
                                title='Installation steps can be found on the "Install" tab'
                            />
                        </div> */}
                        <Button
                            label='Setup steps'
                            severity='success'
                            outlined
                            size='small'
                            onClick={
                                () => {
                                    navigate(`/devices/how_to_connect/?device_id=${searchParams.get('device_id')}`)
                                }
                            }
                        />
                    </div>
                </div>
            </V2Card>
            <DeviceMenu />
        </div>
    );
}

export default DeviceHeader;